function saveLangChange() {
  const isPresent = document.querySelector(".c-region-window-wrapper");
  if (!isPresent) {
    return;
  }

  function triggerLanguageChange() {
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
    }

    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    }

    const languages = document.querySelectorAll("[data-lang]");

    languages.forEach((language) => {
      language.addEventListener("click", function () {
        const lang = language.getAttribute(["data-lang"]);

        setCookie("fractorylang", lang, 365);
      });
    });

    if (getCookie("fractorylang")) {
      const cookieValue = getCookie("fractorylang");
      const pageLang = document.documentElement.lang;

      const setLang = document.querySelector(`[data-lang=${cookieValue}]`);

      if (cookieValue !== pageLang) {
        if (document.body.classList.contains("home")) {
          setLang.click();
        } else {
          // run only if translation exists. meaning that the url has to be longer than simply root.
          if (setLang.href.length > 24) {
            setLang.click();
          }
        }
      }
    } else {
      const regionSelectWindow = document.querySelector(
        ".c-region-window-wrapper"
      );
      const windowClose = document.querySelector(
        ".c-region-window-wrapper .c-gen-window-close"
      );
      regionSelectWindow.classList.remove("hidden");

      windowClose.addEventListener("click", function () {
        regionSelectWindow.classList.add("hidden");
      });
    }
  }

  // if it's not blog archive or blog
  if (
    !(
      document.body.classList.contains("single-post") ||
      document.body.classList.contains("post-type-archive-engineering_hub") ||
      document.body.classList.contains("tax-engineering_hub_category") ||
      document.body.classList.contains("single-engineering_hub") ||
      document.body.classList.contains("blog") ||
      document.body.classList.contains("search")
    )
  ) {
    // if cookie fractorylang says my preferred language is different from the page I am trying to visit, then it changes the language automatically.
    triggerLanguageChange();
  }
}

export default saveLangChange;
